import { Select } from '@oy/uidesktop';
import PropTypes from 'prop-types';

const options = [
  { value: '5', label: '5 Rows' },
  { value: '10', label: '10 Rows' },
  { value: '25', label: '25 Rows' },
  { value: '50', label: '50 Rows' },
  { value: '100', label: '100 Rows' },
];

const NoLabelRecordsLimiter = props => {
  const { onChange, disabled, value } = props;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: '124px',
        }}
      >
        <div>
          <Select
            isDisabled={disabled}
            defaultValue={value}
            options={options}
            onChange={onChange}
            styles={{
              // Fixes the overlapping problem of the component
              menu: provided => ({ ...provided, zIndex: 9999 }),
            }}
            customStyleProps={{
              control: provided => ({
                ...provided,
                minHeight: 40,
              }),
            }}
          />
        </div>
      </div>
    </div>
  );
};

NoLabelRecordsLimiter.propTypes = {
  /** Disable component */
  disabled: PropTypes.bool,
  /** Gets called when the user selects item from the component */
  onChange: PropTypes.func,

  value: PropTypes.object,
};

NoLabelRecordsLimiter.defaultProps = {
  disabled: false,
};

export default NoLabelRecordsLimiter;
